import { keyframes, styled } from '@mui/material/styles';

export const CrashMemberWrapper = styled('div')(({ theme }) => ({
  position: 'absolute',
  right: theme.spacing(3),
  top: '45%',
  transition: 'opacity .5s',
  [theme.breakpoints.down('md')]: {
    transform: 'scale(.6)',
    transformOrigin: 'right top',
  },
}));

export const fadeIn = keyframes`
  0% {
    opacity: 0;
    transform: scale(.2);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`;

interface AnimatedItemProp {
  opacity: number;
}

export const AnimatedItem = styled('div')<AnimatedItemProp>(
  ({ theme, opacity }) => ({
    animation: `${fadeIn} 0.15s`,
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    background: theme.palette.grey[800],
    borderRadius: '20px',
    marginBottom: theme.spacing(1),
    opacity: opacity,
    transition: 'opacity .5s',
    '& svg': {
      marginLeft: theme.spacing(0.25),
    },
  }),
);
